import type { ReactNode } from "react";

type Props = {
  eyebrow?: string;
  title: ReactNode;
  desc?: string;
  action?: { label: string; href: string };
  className?: string;
};

export default function SectionHeading({ eyebrow, title, desc, action, className = "" }: Props) {
  return (
    <div className={`flex flex-col gap-4 border-b border-background-200 pb-5 md:flex-row md:items-end md:justify-between ${className}`}>
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="inline-block h-3 w-0.5 bg-primary-500" aria-hidden="true"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[28px]">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && (
        <a
          href={action.href}
          className="group inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
        >
          {action.label}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </a>
      )}
    </div>
  );
}